module.exports = __webpack_public_path__ + "static/media/merlinIcons.1befa21e.ttf";